

export default class Controller {

	/**
	 * A place to store and handle persistent game data between scenes,
	 * background processes, game init, etc.
	 * @param {Object} args 
	 */
	constructor(args) {
		this.system = args.system;
	}

	getConfig() {
		// to be overridden
		// ... return {}
	}

	init() {
		// to be overridden
		// define game vars etc.
	}

	start() {
		// to be overridden
		// reset vars, etc, change to title screen, etc.
	}

	update(delta, deltaNormal) {
		// to be overridden
		// per-frame updates ...
	}

}